export default __webpack_public_path__ + "static/media/onboarding-finish.9c903471.svg";